<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Artículos</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1" *ngIf="swMaintenanceOrder">Ficha Técnica</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [variant]="undefined" [severity]="'success'" (onClick)="newRegister()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-table [showExport]="true" [showImport]="true" [showRecover]="true" [headers]="articleHeader"
        [data]="articleData" [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="url"
        (onRecoverData)="getAllArticlesWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()" (onImport)="onImport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1" *ngIf="swMaintenanceOrder">
      <app-custom-table [showExport]="true" [showImport]="true" [showRecover]="true" [headers]="equipmentLogbookHeader"
        [data]="equipmentLogbookData" [actions]="tableActionsHV" [previousFilters]="filters"
        [filterPersistentKey]="'article'" (onRecoverData)="getAllEquipmentLogbooksWithPagination()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onImport)="onImport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
<!-- Modal para importar artículos -->
<app-custom-modal #articleImportModal [label]="'Importar Artículos'" [width]="'40rem'" [header]="'Importar Artículos'"
  [children]="componentArticleImportModal" [inputs$]="inputsForArticleModals$" (params)="reloadList($event.reload)"
  hidden>
</app-custom-modal>

<!-- Modal para importar hojas de vida -->
<app-custom-modal #equipmentLogbookImportModal [label]="'Importar Ficha Técnica'" [width]="'40rem'"
  [header]="'Importar Ficha Técnica'" [children]="componentEquipmentLogbookImportModal"
  (params)="reloadList($event.reload)" hidden>
</app-custom-modal>